import React, { useRef, useEffect } from "react";
import classnames from "classnames";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  lightMode: state.page.lightMode,
});

function Icon({ classNames, icon, reference, style, lightMode }) {
  const gitRef = useRef(null);
  const jsRef = useRef(null);
  const reduxRef = useRef(null);
  const sassRef = useRef(null);
  const reactRef = useRef(null);
  const coffeeRef = useRef(null);
  const bookRef = useRef(null);
  const codeRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      switch (icon) {
        case "redux":
          if (reduxRef.current) {
            reduxRef.current.classList.remove("icon__redux--initial");
            reduxRef.current.classList.add("icon__redux--animated");
          }
          break;
        case "git":
          if (gitRef.current) {
            gitRef.current.classList.remove("icon__git--initial");
            gitRef.current.classList.add("icon__git--animated");
          }
          break;
        case "js":
          if (jsRef.current) {
            jsRef.current.classList.remove("icon__js--initial");
            jsRef.current.classList.add("icon__js--animated");
          }
          break;
        case "sass":
          if (sassRef.current) {
            sassRef.current.classList.remove("icon__sass--initial");
            sassRef.current.classList.add("icon__sass--animated");
          }
          break;
        case "react":
          if (reactRef.current) {
            reactRef.current.classList.remove("icon__react--initial");
            reactRef.current.classList.add("icon__react--animated");
          }
          break;
        case "coffee":
          if (coffeeRef.current) {
            coffeeRef.current.classList.remove("icon__coffeeIcon--initial");
            coffeeRef.current.classList.add("icon__coffeeIcon--animated");
          }
          break;
        case "codeIcon":
          if (codeRef.current) {
            codeRef.current.classList.remove("icon__codeIcon--initial");
            codeRef.current.classList.add("icon__codeIcon--animated");
          }
          break;
        case "book":
          if (bookRef.current) {
            bookRef.current.classList.remove("icon__bookIcon--initial");
            bookRef.current.classList.add("icon__bookIcon--animated");
          }
          break;
        default:
          break;
      }
    }, 3400);
  }, [icon]);

  useEffect(() => {
    switch (icon) {
      case "redux":
        reduxRef.current && lightMode
          ? reduxRef.current.classList.add("icon--lightMode")
          : reduxRef.current.classList.remove("icon--lightMode");
        break;
      case "js":
        jsRef.current && lightMode
          ? jsRef.current.classList.add("icon--lightMode")
          : jsRef.current.classList.remove("icon--lightMode");
        break;
      case "react":
        reactRef.current && lightMode
          ? reactRef.current.classList.add("icon--lightMode")
          : reactRef.current.classList.remove("icon--lightMode");
        break;
      case "sass":
        sassRef.current && lightMode
          ? sassRef.current.classList.add("icon--lightMode")
          : sassRef.current.classList.remove("icon--lightMode");
        break;
      case "git":
        gitRef.current && lightMode
          ? gitRef.current.classList.add("icon--lightMode")
          : gitRef.current.classList.remove("icon--lightMode");
        break;
      case "coffee":
        coffeeRef.current && lightMode
          ? coffeeRef.current.classList.add("icon--lightMode")
          : coffeeRef.current.classList.remove("icon--lightMode");
        break;
      case "codeIcon":
        codeRef.current && lightMode
          ? codeRef.current.classList.add("icon--lightMode")
          : codeRef.current.classList.remove("icon--lightMode");
        break;
      case "book":
        bookRef.current && lightMode
          ? bookRef.current.classList.add("icon--lightMode")
          : bookRef.current.classList.remove("icon--lightMode");
        break;
      default:
        break;
    }
  });

  if (icon === "react") {
    const reactClassNames = classnames(
      "icon icon__react icon__react--initial",
      classNames
    );
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        version="1.1"
        viewBox="0 0 841.9 595.3"
        xmlSpace="preserve"
        ref={reactRef}
        className={reactClassNames}
        onMouseEnter={() =>
          reactRef.current.classList.add("icon__react--hovered")
        }
      >
        <g>
          <path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6z"></path>
          <path d="M320.8 78.4L320.8 78.4 320.8 78.4z"></path>
          <circle cx="420.9" cy="296.5" r="45.7"></circle>
          <path d="M520.5 78.1L520.5 78.1 520.5 78.1z"></path>
        </g>
      </svg>
    );
  } else if (icon === "sass") {
    const sassClassNames = classnames(
      "icon icon__sass icon__sass--initial",
      classNames
    );
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        version="1.1"
        viewBox="0 0 547.8 410.6"
        xmlSpace="preserve"
        ref={sassRef}
        className={sassClassNames}
        onMouseEnter={() =>
          sassRef.current.classList.add("icon__sass--hovered")
        }
      >
        <path d="M471.4 236c-19.1.1-35.7 4.7-49.6 11.5-5.1-10.1-10.2-19.1-11.1-25.7-1-7.7-2.2-12.4-1-21.6 1.2-9.2 6.6-22.3 6.5-23.3s-1.2-5.7-12.2-5.8c-11-.1-20.5 2.1-21.6 5-1.1 2.9-3.2 9.5-4.6 16.3-1.9 10-22 45.7-33.5 64.4-3.7-7.3-6.9-13.7-7.6-18.8-1-7.7-2.2-12.4-1-21.6 1.2-9.2 6.6-22.3 6.5-23.3-.1-1-1.2-5.7-12.2-5.8-11-.1-20.5 2.1-21.6 5-1.1 2.9-2.3 9.7-4.6 16.3-2.3 6.6-29 66.2-36 81.6-3.6 7.9-6.7 14.2-8.9 18.5s-.1.3-.4.8c-1.9 3.7-3 5.7-3 5.7v.1c-1.5 2.7-3.1 5.2-3.9 5.2-.6 0-1.7-7.2.2-17 4-20.7 13.5-52.9 13.4-54 0-.6 1.8-6.2-6.2-9.1-7.8-2.9-10.6 1.9-11.3 1.9-.7 0-1.2 1.7-1.2 1.7s8.7-36.2-16.6-36.2c-15.8 0-37.6 17.3-48.4 32.9-6.8 3.7-21.3 11.6-36.8 20.1-5.9 3.3-12 6.6-17.7 9.7-.4-.4-.8-.9-1.2-1.3-30.6-32.7-87.2-55.8-84.8-99.7.9-16 6.4-58 108.7-109 84.2-41.5 151.2-30 162.8-4.5 16.6 36.4-35.9 104-122.9 113.8-33.2 3.7-50.6-9.1-55-13.9-4.6-5-5.3-5.3-7-4.3-2.8 1.5-1 6 0 8.6 2.6 6.8 13.3 18.8 31.4 24.7 16 5.2 54.9 8.1 102-10.1 52.7-20.4 93.9-77.1 81.8-124.6C330.7 2 250.7-13.9 175 13 130 29 81.2 54.2 46.1 87 4.4 126-2.2 159.9.5 174.1c9.7 50.4 79.2 83.2 107 107.5-1.4.8-2.7 1.5-3.8 2.1-13.9 6.9-66.9 34.6-80.1 63.9-15 33.2 2.4 57 13.9 60.2 35.7 9.9 72.4-7.9 92.1-37.3 19.7-29.4 17.3-67.6 8.2-85.1-.1-.2-.2-.4-.4-.6 3.6-2.1 7.3-4.3 10.9-6.4 7.1-4.2 14.1-8.1 20.1-11.3-3.4 9.3-5.9 20.4-7.1 36.4-1.5 18.8 6.2 43.2 16.3 52.8 4.5 4.2 9.8 4.3 13.2 4.3 11.8 0 17.1-9.8 23-21.4 7.2-14.2 13.7-30.7 13.7-30.7s-8.1 44.6 13.9 44.6c8 0 16.1-10.4 19.7-15.7v.1s.2-.3.6-1c.8-1.3 1.3-2.1 1.3-2.1v-.2c3.2-5.6 10.4-18.3 21.1-39.4 13.8-27.2 27.1-61.2 27.1-61.2s1.2 8.3 5.3 22.1c2.4 8.1 7.4 17 11.4 25.6-3.2 4.5-5.2 7-5.2 7l.1.1c-2.6 3.4-5.4 7.1-8.5 10.7-10.9 13-23.9 27.9-25.7 32.2-2.1 5.1-1.6 8.8 2.4 11.8 2.9 2.2 8.1 2.5 13.4 2.2 9.8-.7 16.7-3.1 20.1-4.6 5.3-1.9 11.5-4.8 17.3-9.1 10.7-7.9 17.2-19.2 16.6-34.1-.3-8.2-3-16.4-6.3-24.1 1-1.4 1.9-2.8 2.9-4.2 16.9-24.7 30-51.8 30-51.8s1.2 8.3 5.3 22.1c2 7 6.1 14.6 9.7 22-15.9 12.9-25.7 27.9-29.2 37.7-6.3 18.2-1.4 26.4 7.9 28.3 4.2.9 10.2-1.1 14.6-3 5.6-1.8 12.2-4.9 18.5-9.5 10.7-7.9 21-18.9 20.4-33.8-.3-6.8-2.1-13.5-4.6-20 13.5-5.6 30.9-8.7 53.1-6.1 47.6 5.6 57 35.3 55.2 47.8-1.8 12.5-11.8 19.3-15.1 21.4-3.3 2.1-4.4 2.8-4.1 4.3.4 2.2 2 2.1 4.8 1.7 3.9-.7 25-10.1 25.9-33.1 1.5-29.4-26.5-61.5-76-61.2zM104.2 359.8C88.4 377 66.4 383.5 56.9 378c-10.2-5.9-6.2-31.3 13.2-49.5 11.8-11.1 27-21.4 37.1-27.7 2.3-1.4 5.7-3.4 9.8-5.9.7-.4 1.1-.6 1.1-.6l2.4-1.5c7.1 26 .3 48.9-16.3 67zm115-78.2c-5.5 13.4-17 47.7-24 45.8-6-1.6-9.7-27.6-1.2-53.3 4.3-12.9 13.4-28.3 18.7-34.3 8.6-9.6 18.1-12.8 20.4-8.9 2.9 5.1-10.5 42.3-13.9 50.7zm94.9 45.4c-2.3 1.2-4.5 2-5.5 1.4-.7-.4 1-2 1-2s11.9-12.8 16.6-18.6c2.7-3.4 5.9-7.4 9.3-11.9v1.3c0 15.3-14.8 25.6-21.4 29.8zm73.2-16.7c-1.7-1.2-1.4-5.2 4.3-17.7 2.2-4.9 7.4-13.1 16.3-21 1 3.2 1.7 6.3 1.6 9.2-.1 19.3-13.9 26.5-22.2 29.5z"></path>
      </svg>
    );
  } else if (icon === "redux") {
    const reduxClassNames = classnames(
      "icon icon__redux icon__redux--initial",
      classNames
    );
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        x="0"
        y="0"
        viewBox="0 0 50 50"
        ref={reduxRef}
        className={reduxClassNames}
        onMouseEnter={() =>
          reduxRef.current.classList.add("icon__redux--hovered")
        }
      >
        <path d="M24 2c-7.168 0-13 8.292-13 18.486 0 5.095 1.485 9.669 3.842 13.006A4.116 4.116 0 0014 36c0 .972.319 1.958 1.002 2.727C15.685 39.495 16.75 40 18 40c1.25 0 2.315-.505 2.998-1.273C21.681 37.957 22 36.972 22 36s-.319-1.958-1.002-2.727C20.315 32.505 19.25 32 18 32a4.25 4.25 0 00-1.6.313c-2.082-2.995-3.4-7.169-3.4-11.827C13 11.396 17.935 4 24 4c5.419 0 9.923 5.91 10.824 13.65.707.27 1.409.573 2.104.907C36.247 9.267 30.71 2 24 2zm-2 13c-1.25 0-2.315.505-2.998 1.273C18.319 17.043 18 18.028 18 19s.319 1.958 1.002 2.727C19.685 22.495 20.75 23 22 23c1.25 0 2.315-.505 2.998-1.273.427-.48.696-1.05.85-1.643 3.577-.154 7.598.903 11.295 3.12 7.894 4.731 11.87 12.983 8.863 18.392-1.074 1.93-2.95 3.302-5.42 3.963-3.462.928-7.715.357-11.773-1.479-.586.471-1.206.917-1.844 1.348 3.325 1.679 6.843 2.568 10.093 2.568a15.64 15.64 0 004.042-.506c3.007-.805 5.307-2.508 6.65-4.924 3.524-6.342-.775-15.797-9.584-21.078-3.976-2.385-8.344-3.551-12.283-3.424a3.943 3.943 0 00-.889-1.79C24.315 15.503 23.25 15 22 15zm0 2c.75 0 1.185.245 1.502.602.317.356.498.87.498 1.398 0 .528-.181 1.042-.498 1.398-.317.357-.752.602-1.502.602s-1.185-.245-1.502-.602C20.181 20.042 20 19.528 20 19c0-.528.181-1.042.498-1.398.317-.357.752-.602 1.502-.602zM9.162 23.332c-6.964 5.44-10.06 13.574-6.914 19.234 1.343 2.416 3.643 4.117 6.65 4.922 1.271.34 2.63.508 4.041.508 3.8 0 7.972-1.208 11.768-3.484 4.556-2.732 7.837-6.579 9.506-10.533 1.155-.056 2.142-.53 2.785-1.252C37.681 31.957 38 30.972 38 30s-.319-1.958-1.002-2.727C36.315 26.505 35.25 26 34 26c-1.25 0-2.315.505-2.998 1.273C30.319 28.043 30 29.028 30 30s.319 1.958 1.002 2.727c.332.373.758.68 1.248.902-1.568 3.409-4.535 6.748-8.572 9.168-4.75 2.849-10.082 3.882-14.264 2.762-2.472-.662-4.345-2.032-5.418-3.963-2.542-4.573-.081-11.168 5.506-15.961a27.027 27.027 0 01-.34-2.303zM34 28c.75 0 1.185.245 1.502.602.317.356.498.87.498 1.398 0 .528-.181 1.042-.498 1.398-.317.357-.752.602-1.502.602s-1.185-.245-1.502-.602C32.181 31.042 32 30.528 32 30c0-.528.181-1.042.498-1.398.317-.357.752-.602 1.502-.602zm-16 6c.75 0 1.185.245 1.502.602.317.356.498.87.498 1.398 0 .528-.181 1.042-.498 1.398-.317.357-.752.602-1.502.602s-1.185-.245-1.502-.602C16.181 37.042 16 36.528 16 36c0-.528.181-1.042.498-1.398.317-.357.752-.602 1.502-.602z"></path>
      </svg>
    );
  } else if (icon === "js") {
    const jsClassNames = classnames(
      "icon icon__js icon__js--initial",
      classNames
    );
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        ref={jsRef}
        className={jsClassNames}
        onMouseEnter={() => jsRef.current.classList.add("icon__js--hovered")}
      >
        <path d="M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"></path>
      </svg>
    );
  } else if (icon === "git") {
    const gitClassNames = classnames(
      "icon icon__git icon__git--initial",
      classNames
    );
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="114.862"
        height="114.862"
        version="1.1"
        viewBox="0 0 114.862 114.862"
        xmlSpace="preserve"
        ref={gitRef}
        className={gitClassNames}
        onMouseEnter={() => gitRef.current.classList.add("icon__git--hovered")}
      >
        <g transform="matrix(1.25 0 0 -1.25 0 114.862)">
          <g transform="scale(.1)">
            <path
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M901.547 500.352L500.355 901.527c-23.093 23.11-60.566 23.11-83.691 0l-83.301-83.316 105.676-105.676c24.559 8.293 52.723 2.727 72.293-16.847 19.688-19.696 25.207-48.102 16.699-72.75l101.856-101.844c24.648 8.496 53.066 3.004 72.754-16.711 27.5-27.492 27.5-72.059 0-99.574-27.52-27.516-72.078-27.516-99.61 0-20.683 20.703-25.801 51.097-15.312 76.582l-95 94.992V326.414c6.699-3.32 13.027-7.742 18.613-13.312 27.5-27.497 27.5-72.059 0-99.598-27.5-27.488-72.09-27.488-99.57 0-27.5 27.539-27.5 72.101 0 99.598 6.797 6.789 14.668 11.925 23.066 15.363v252.281a69.79 69.79 0 00-23.066 15.367c-20.828 20.821-25.84 51.395-15.157 76.977L292.426 777.285 17.328 502.211c-23.105-23.129-23.105-60.602 0-83.711L418.54 17.324c23.098-23.105 60.559-23.105 83.691 0l399.317 399.317c23.117 23.113 23.117 60.605 0 83.711"
            ></path>
          </g>
        </g>
      </svg>
    );
  } else if (icon === "arrow") {
    const arrowClassNames = classnames(
      "arrow",
      lightMode && "arrow--lightMode",
      classNames
    );
    return (
      <svg
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        width="5rem"
        height="3rem"
        fill="none"
        viewBox="0 0 202 177"
        className={arrowClassNames}
        ref={reference}
      >
        <path
          // fill="white"
          fillRule="evenodd"
          d="M150.73 124.944c.055-.598-2.086-1.342-5.98-2.386-3.894-1.044-9.545-2.406-16.462-4.463s-15.103-4.823-23.97-8.668c-8.867-3.845-18.412-8.776-27.949-15.008a178.097 178.097 0 01-16.853-12.49c-10.664-8.918-19.775-18.664-27.235-28.19-7.46-9.526-13.274-18.824-17.728-26.887-4.454-8.063-7.57-14.89-9.796-19.62-1.112-2.364-2.002-4.206-2.706-5.431C1.347.576.829-.032.497.06.165.157.035.949.12 2.376c.085 1.426.386 3.487.951 6.1 1.132 5.226 3.325 12.681 7.133 21.487S17.463 48.92 24.905 59.27A166.647 166.647 0 0053.101 89.6a161.746 161.746 0 0018.002 13.066 161.69 161.69 0 0030.06 14.683c9.534 3.48 18.309 5.637 25.683 6.915 7.374 1.278 13.349 1.691 17.46 1.687 4.112-.004 6.365-.408 6.421-1.006h.003z"
          clipRule="evenodd"
        ></path>
        <path
          // fill="white"
          fillRule="evenodd"
          d="M128.6 76.464c-.426.485 1.116 2.654 4.326 6.076 3.21 3.422 8.089 8.095 14.312 13.666 6.223 5.571 13.79 12.038 22.348 19.13 8.558 7.092 18.107 14.809 28.269 22.959a153.47 153.47 0 00-11.147.706c-13.648 1.361-26.242 4.407-37.465 8.045-11.223 3.638-21.082 7.85-29.362 11.816-18.945 9.747-30.533 16.547-29.918 17.879.614 1.332 13.308-3.071 33.02-11.157 8.762-3.896 19.044-8.519 30.464-12.955 11.42-4.435 23.973-8.665 37.267-11.337a151.134 151.134 0 0110.8-1.776c-9.801-9.386-19.119-18.242-27.632-26.146-8.513-7.903-16.222-14.855-22.779-20.51-6.557-5.657-11.963-10.018-15.843-12.824-3.88-2.806-6.233-4.058-6.659-3.573l-.001.001z"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  } else if (icon === "arrow-straight") {
    const arrowClassNames = classnames(
      "arrow-straight",
      lightMode && "arrow-straight--lightMode",
      classNames
    );
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="svg2"
        x="0"
        y="0"
        enableBackground="new 0 0 252 99.1"
        version="1.1"
        viewBox="0 0 252 99.1"
        xmlSpace="preserve"
        className={arrowClassNames}
      >
        <style></style>
        <g id="layer1" transform="translate(0 -552.36)">
          <g id="g3083" transform="translate(-30.488 19.512)">
            <path
              id="path2997"
              d="M71.7 581.9c0-2.8 43.9-5.4 98.1-5.8 54.2-.5 98.2 1.4 98.2 4.2 0 2.8-43.9 5.4-98.1 5.8-54.2.5-98.2-1.4-98.2-4.2z"
              className="st0"
            ></path>
            <path
              id="path3009"
              d="M35.4 588.6c.2-1 2.7-1.5 6.9-1.3s10.1 1.1 16.9 3.2c5.6 1.7 11.7 4.3 17.7 7.7 5.2 3 9.9 6.3 13.8 9.6 4 3.3 7.2 6.7 9.7 9.7s4.3 5.6 5.3 7.6 1.3 3.3.7 3.8c-.5.5-1.8 0-3.6-1.1s-4.3-2.9-7.2-5.1c-3-2.2-6.5-4.8-10.4-7.5-4-2.7-8.4-5.5-13.2-8.2-5.6-3.2-11-5.8-15.9-8.1-6-2.7-11.2-4.7-14.9-6.4-3.8-1.7-5.9-3-5.8-3.9z"
              className="st0"
            ></path>
            <path
              id="path3009-4"
              d="M34.8 579.9c-.2-1 2-2.2 5.7-3.8s8.9-3.7 14.9-6.4c4.9-2.2 10.4-4.9 15.9-8.1 4.8-2.7 9.2-5.5 13.2-8.2 4-2.7 7.5-5.3 10.4-7.5 3-2.2 5.4-4 7.2-5.1s3.1-1.6 3.6-1.1.3 1.8-.7 3.8-2.8 4.6-5.3 7.6-5.8 6.3-9.7 9.7-8.6 6.6-13.8 9.6c-6.1 3.4-12.2 6-17.7 7.7-6.8 2.1-12.7 3-16.9 3.2-4.1.1-6.6-.5-6.8-1.4z"
              className="st0"
            ></path>
          </g>
        </g>
      </svg>
    );
  } else if (icon === "codeIcon") {
    return (
      <svg
        className="icon icon__codeIcon icon__codeIcon--initial"
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        enableBackground="new 0 0 320 320"
        version="1.1"
        viewBox="0 0 320 320"
        xmlSpace="preserve"
        ref={codeRef}
      >
        <path d="M292.697 19.995H27.303C12.223 19.995 0 32.219 0 47.299v163.822c0 15.079 12.223 27.304 27.303 27.304H133.79v24.7h-21.544c-10.185 0-18.439 8.255-18.439 18.44 0 10.184 8.255 18.44 18.439 18.44h95.508c10.186 0 18.439-8.256 18.439-18.44 0-10.185-8.254-18.44-18.439-18.44H186.21v-24.7h106.487c15.08 0 27.303-12.225 27.303-27.304V47.299c0-15.08-12.223-27.304-27.303-27.304zm-4.369 186.757H31.672V51.667h256.656v155.085z"></path>
        <path d="M131.135 159.999a7 7 0 01-4.494-1.622L99.512 135.86a7.04 7.04 0 010-10.834l27.129-22.517a7.04 7.04 0 019.912.921 7.038 7.038 0 01-.92 9.913l-20.603 17.099 20.603 17.102a7.04 7.04 0 01-4.498 12.455zM188.867 159.999a7.04 7.04 0 01-4.5-12.456l20.602-17.102-20.602-17.099a7.04 7.04 0 018.993-10.834l27.127 22.517a7.034 7.034 0 010 10.834l-27.127 22.517a7.011 7.011 0 01-4.493 1.623zM147.072 182.146a7.038 7.038 0 01-6.764-8.999l25.859-89.324a7.043 7.043 0 018.721-4.805 7.044 7.044 0 014.805 8.722l-25.861 89.324a7.043 7.043 0 01-6.76 5.082z"></path>
      </svg>
    );
  } else if (icon === "coffee") {
    return (
      <svg
        className="icon icon__coffeeIcon icon__coffeeIcon--initial"
        xmlns="http://www.w3.org/2000/svg"
        id="Ebene_1"
        enableBackground="new 0 0 256 256"
        version="1.1"
        viewBox="0 0 256 256"
        xmlSpace="preserve"
        ref={coffeeRef}
      >
        <style></style>
        <path d="M183.2 83.3l-2.1-12.7c-.6-3.6-3.5-6.2-7-6.6l-4.6-18c-.9-3.5-4.1-6-7.8-6H94.2c-3.7 0-6.9 2.5-7.8 6.1L82 64c-3.6.4-6.5 3-7.1 6.6l-2.1 12.7c-.4 2.4 1.5 4.7 3.9 4.7h3.7l2.5 24h-.6c-2.4 0-4.2 2-4 4.4l7.6 80c.2 2.1 1.9 3.6 4 3.6h2.3l3.9 36.4c.2 2 1.9 3.6 4 3.6h56.8c2.1 0 3.8-1.6 4-3.6l3.6-36.4h1.5c2.1 0 3.8-1.6 4-3.6l7.6-80c.2-2.3-1.6-4.4-4-4.4h-.3l2.4-24h3.5c2.5 0 4.4-2.2 4-4.7zm-8.6-3.3H81.4l1.3-8h90.4l1.5 8zM94.2 48h67.5l4.1 16H90.2l4-16zm59.1 184h-49.6l-3.4-32h56.2l-3.2 32zm9.1-40H93.6l-6.8-72h82.4l-6.8 72zm2.9-80H91l-2.5-24h79.3l-2.5 24z"></path>
        <path d="M120.1 165.2c4.3 2.7 7.4 6.5 7.9 8.1.4-1.6 3.8-5.4 7.9-8.2 4.4-3 11.2-5.5 11.1-12.5-.1-12.9-14.3-14.9-19-4.3-4.9-11.1-18.9-8.5-19 4.4-.1 7.1 6.7 9.7 11.1 12.5z"></path>
      </svg>
    );
  } else if (icon === "book") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        viewBox="0 0 1000 1000"
        className="icon icon__bookIcon icon__bookIcon--initial"
        ref={bookRef}
      >
        <path d="M985.2 279.9c-1.3-2.1-22.6-39.2-65.3-77.3-42.3-37.9-108.1-77.3-194.6-77.3-86.6 0-151.7 39.5-193.3 77.6-12.8 11.8-23.6 23.4-32.5 34-9.1-10.7-20.4-22.4-33.5-34.3-42.5-37.9-108.2-77.3-194.8-77.3-86.6 0-151.6 39.5-193.3 77.6-41.8 38.2-62.2 75.4-63.4 77.6L10 297.6v559.3L77 874l.1.1c.9-1.9 19.1-33 52-61.9 33.3-29.2 79.7-56.1 141.9-56.3 64.1 0 112.9 28.9 147.2 59.4 16.9 15.1 30.2 30.4 38.6 41.7 4.4 5.7 7.4 10.4 9.5 13.4.9 1.6 1.7 2.8 2.1 3.6.2.3.4.6.4.7h.2l62.2-.6.1-.1v-.1c1.4-2.6 19.5-33.1 51.9-61.7 33.5-29.2 79.9-56.1 142-56.3 64.1 0 112.8 28.9 147.2 59.4 17 15.1 29.9 30.4 38.5 41.7 4.4 5.7 7.5 10.4 9.6 13.4 1 1.6 1.7 2.8 2.1 3.6.3.3.4.6.4.7h.1l66.8-17.8V297.6l-4.7-17.7zM271.1 684.5c-84.2 0-147.9 37.3-189.5 74.3V307.7c7.4-11.2 23.4-33.4 47.6-54.8 33.3-29.2 79.7-56.1 141.9-56.1 64.1 0 112.9 28.9 147.2 59.3 16.9 15.1 30.2 30.5 38.6 41.9 3 3.9 5.5 7.4 7.2 10.1v452.5c-42.2-37.5-107.4-76.1-193-76.1zm647.3 76c-42.5-37.5-107.6-76-193.1-76-84.1-.1-147.9 37.3-189.6 74.3V307.7c7.4-11.1 23.5-33.4 47.6-54.8 33.5-29.2 79.9-56.1 142-56.1 64.1 0 112.8 28.9 147.2 59.3 17 15.1 29.9 30.5 38.5 41.9 3.1 3.9 5.5 7.4 7.4 10.1v452.4z"></path>
      </svg>
    );
  } else {
    return null;
  }
}

export default connect(mapStateToProps)(Icon);
